import { cloneDeep } from "lodash";
import { checkChanged } from "./checkChanged";
import { ITlfActionLoadTlf, TlfContextProps } from "./interface";

/**
 * Loads TLF data into context and resets undo/save history for the new item.
 *
 * @param state - Current TLF context state.
 * @param action - Load action containing the next TLF payload and view flags.
 * @returns Updated state initialised from the loaded TLF item.
 */
export const tlf_loadTlf = (state: TlfContextProps, action: ITlfActionLoadTlf): TlfContextProps => {
  const newState = { ...state };

  newState.ixTlfDataVersion = 0;
  newState.ixSaveVersion = 0;
  newState.tlfData = action.tlfData;
  newState.tlfDataVersions = [cloneDeep(action.tlfData)];
  newState.showModalWindow = "";
  newState.isSubscribed = action.isSubscribed;
  newState.readOnly = action.readOnly;
  newState.isTlfNew = action.isTlfNew;
  checkChanged(newState);

  return newState;
};
